export const TAG_INPUT_NAME = 'tags';
export const TAG_INPUT_LABEL = 'Publish in...';
export const TAG_PLACEHOLDER = 'Type to search';
